"use client";

import { useEffect } from "react";
import Link from "next/link";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useTranslations } from "@/i18n/LocaleProvider";

export default function Error({
  error,
  retry,
}: {
  error: Error & { digest?: string };
  retry: () => void;
}) {
  const { t } = useTranslations();

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <>
      <Header />
      <main className="mx-auto w-full max-w-md px-6 py-24 text-center">
        <h1 className="font-display text-4xl">{t("errors.serverErrorTitle")}</h1>
        <p className="mt-4 text-foreground/70">{t("errors.serverErrorBody")}</p>
        <div className="mt-8 flex justify-center gap-4">
          <button
            onClick={retry}
            className="rounded-xl bg-accent px-6 py-3 font-semibold text-accent-foreground"
          >
            {t("errors.tryAgain")}
          </button>
          <Link
            href="/"
            className="rounded-xl border border-foreground/20 px-6 py-3 font-semibold"
          >
            {t("errors.backHome")}
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}
